import { Grid, makeStyles, Theme, Box, Button, Container, Link, useTheme, useMediaQuery } from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { colors } from "swyft-react-core";
import { Link as RouterLink } from "react-router-dom";
import { TF } from "./typography/TF";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import {
  SwyftContactCorkPhoneNumber,
  SwyftContactCorkPhoneNumberLink,
  SwyftContactDublinPhoneNumber,
  SwyftContactDublinPhoneNumberLink,
  SwyftEmail,
  SwyftEmailLink
} from "../app/consts";
import { LogoSwyftWhyte } from "./Icons";

export const Footer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Box overflow="hidden">
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <LogoSwyftWhyte className={classes.logo} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Button
                  target="_blank"
                  href="https://www.swyftenergy.ie/"
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                  fullWidth
                >
                  SwyftEnergy
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="left">
                <TF variant="h5" paragraph>
                  Want to chat with us?
                </TF>

                <Box mt={2}>
                  <Box display="flex" textAlign="left">
                    <Box>
                      <SmartphoneIcon />
                    </Box>
                    <Box>
                      <TF gutterBottom>
                        Cork:&nbsp;&nbsp;&nbsp;{" "}
                        <Link href={SwyftContactCorkPhoneNumberLink}>{SwyftContactCorkPhoneNumber}</Link>
                      </TF>
                      <TF gutterBottom>
                        Dublin: <Link href={SwyftContactDublinPhoneNumberLink}>{SwyftContactDublinPhoneNumber}</Link>
                      </TF>
                    </Box>
                  </Box>
                </Box>

                <Box mt={3} textAlign="left">
                  <Link href={SwyftEmailLink} className={classes.opacity}>
                    <MailOutlineIcon />
                    <TF upperCase component="span">
                      {SwyftEmail}
                    </TF>
                  </Link>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="left">
                <TF variant="h5" paragraph>
                  You can find us at
                </TF>
                <Box display="flex" mt={2} textAlign="left">
                  <Box>
                    <RoomOutlinedIcon />
                  </Box>
                  <Box>
                    <TF>Cork:</TF>
                    <TF>
                      The Rubicon Centre, <br />
                      Bishopstown, Cork
                    </TF>
                  </Box>
                </Box>
                <Box display="flex" mt={3} textAlign="left">
                  <Box>
                    <RoomOutlinedIcon />
                  </Box>
                  <Box>
                    <TF>Dublin:</TF>
                    <TF>
                      The Linc Learning &amp; Innovation Centre, Blanchardstown Rd N, Blanchardstown, <br />
                      Dublin 15, D15 YV78​
                    </TF>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box className={classes.social} textAlign={isSmall ? "left" : "center"}>
                <Link href="https://www.facebook.com/swyftenergy/" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon fontSize="large" />
                </Link>
                <Link href="https://www.instagram.com/swyftenergy.ie" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon fontSize="large" />
                </Link>
                <Link
                  href="https://www.youtube.com/channel/UCmqS5nkzn6CMeb-iIYPMHdA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <YouTubeIcon fontSize="large" />
                </Link>
                <Link href="https://www.linkedin.com/company/swyft-energy" target="_blank" rel="noopener noreferrer">
                  <LinkedInIcon fontSize="large" />
                </Link>
              </Box>
              <Box className={classes.social} mt={5}>
                <Button
                  target="_blank"
                  href="https://www.google.com/search?q=swyft+energy#lrd=0x484491de0e84a343:0x3beb06c85e8b977f,1"
                  variant="contained"
                  color="secondary"
                  fullWidth
                >
                  Leave A Review
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <TF variant="caption" className={classes.opacity}>
                Swyft Energy &copy; {year}
              </TF>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TF variant="caption" className={classes.opacity}>
                <Link component={RouterLink} to="/terms">
                  Terms &amp; Conditions
                </Link>
              </TF>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TF variant="caption" className={classes.opacity}>
                <Link component={RouterLink} to="/privacy">
                  Privacy Policy
                </Link>
              </TF>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </footer>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  logo: {
    width: "280px",
    [theme.breakpoints.down("md")]: {
      width: "140px"
    }
  },
  social: {
    "& a": {
      margin: "0 0.5em"
    }
  },
  footer: {
    "paddingTop": theme.spacing(6),
    "backgroundColor": colors.primary,
    "color": colors.white,
    "textAlign": "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left"
    },
    "& a": {
      color: colors.white
    }
  },
  opacity: {
    opacity: 0.87
  },
  button: {
    marginBottom: theme.spacing(4)
  }
}));
